import React, { useState, useEffect } from 'react';
import './Home.css';
import AnimatedSection from './components/AnimatedSection';

function Home() {
  const whatsappNumber = '905344470058';

  const projects = [
    {
      id: 1,
      title: 'Tiktok Sumo Güreşi',
      description: 'Canlı yayınlar için geliştirilmiş, etkileşim odaklı sumo güreşi mekaniği.',
      image: '/sumo.jpeg'
    },
    {
      id: 2,
      title: 'Pokemon Projesi',
      description: 'Strateji ve eğlenceyi bir araya getiren, yeni nesil Pokemon etkileşim uygulaması.',
      image: '/pok.jpeg'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Otomatik geçiş
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
  };

  const getWhatsappUrl = (projectName) => {
    const message = projectName 
      ? `Merhaba, ${projectName} projeniz hakkında detaylı bilgi almak istiyorum.`
      : 'Merhaba, projeleriniz hakkında detaylı bilgi almak istiyorum.';
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  };

  return (
    <main className="landing">
      {/* Hero Section - Kayar Liste Yapısı */}
      <AnimatedSection>
        <section id="hero" className="landing-hero slider-section">
          <div className="container slider-container">
            
            {/* Sol Ok */}
            <button className="slider-arrow left" onClick={prevSlide}>&#10094;</button>

            <div className="slider-content-wrapper">
              <div 
                className="slider-track" 
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {projects.map((project, index) => (
                  <div key={project.id} className="hero-slide">
                    <div className="landing-hero-grid">
                      <div className="landing-hero-text">
                        <div className="landing-badge">Öne Çıkan Proje</div>
                        <h1>{project.title}</h1>
                        <p>{project.description}</p>
                        <div className="landing-actions">
                          <a href={getWhatsappUrl(project.title)} className="btn" target="_blank" rel="noopener noreferrer">
                            Detaylı Bilgi Al
                          </a>
                        </div>
                      </div>
                      <div className="landing-hero-media">
                        <img src={project.image} alt={project.title} className="hero-slider-img" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Sağ Ok */}
            <button className="slider-arrow right" onClick={nextSlide}>&#10095;</button>

            {/* Sayfa Belirteçleri (Dots) */}
            <div className="slider-dots">
              {projects.map((_, index) => (
                <span 
                  key={index} 
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Projects Section (Alt kısım sabit liste olarak kalabilir) */}
      <AnimatedSection>
        <section id="projects" className="section landing-projects">
          <div className="container">
            <h2>Tüm Projeler</h2>
            <div className="landing-projects-grid">
              {projects.map((project) => (
                <div key={project.id} className="landing-project-card">
                  <div className="landing-project-media">
                    <img src={project.image} alt={project.title} />
                  </div>
                  <div className="landing-project-content">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <a href={getWhatsappUrl(project.title)} className="btn" target="_blank" rel="noopener noreferrer">
                      Bilgi Al
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Contact Section */}
      <AnimatedSection>
        <section id="contact" className="section landing-contact">
          <div className="container">
            <h2>İletişim</h2>
            <div className="landing-contact-grid">
              <a className="landing-contact-card" href={getWhatsappUrl()} target="_blank" rel="noopener noreferrer">
                <div className="landing-contact-title">WhatsApp</div>
                <div className="landing-contact-value">+90 534 447 00 58</div>
                <div className="landing-contact-cta">Mesaj gönder</div>
              </a>
              <a className="landing-contact-card" href="mailto:selmanatabek@hotmail.com">
                <div className="landing-contact-title">E-posta</div>
                <div className="landing-contact-value">selmanatabek@hotmail.com</div>
                <div className="landing-contact-cta">Mail gönder</div>
              </a>
            </div>
          </div>
        </section>
      </AnimatedSection>
    </main>
  );
}

export default Home;